import React, { useEffect } from 'react';
import './LegalModal.css';

const CONFIGS = {
  terms: {
    title: 'Terminos de Servicio',
    icon: 'ri-file-text-line',
    intro: 'Aqui tienes un resumen de los terminos que rigen nuestros servicios:',
    points: [
      { icon: 'ri-government-line', text: 'Global Mobility Group LLC te ayuda a gestionar tu solicitud de inmigracion en Espana.' },
      { icon: 'ri-information-line', text: 'No garantizamos la aprobacion; las decisiones son de las autoridades espanolas.' },
      { icon: 'ri-file-shield-2-line', text: 'Debes proporcionar informacion veraz y documentos autenticos.' },
      { icon: 'ri-money-euro-circle-line', text: 'Honorarios: 250EUR por persona (IVA incluido cuando aplique). Las tasas administrativas gubernamentales no estan incluidas y se comunican por separado.' },
      { icon: 'ri-close-circle-line', text: 'Puedes cancelar en cualquier momento contactando a legal@globalmobility.law.' },
    ],
    fullLink: 'https://globalmobility.law/terminos-servicio',
  },
  privacy: {
    title: 'Politica de Privacidad',
    icon: 'ri-shield-check-line',
    intro: 'En Global Mobility Group LLC nos tomamos en serio la privacidad de tus datos. Aqui tienes un resumen de como los tratamos:',
    points: [
      { icon: 'ri-file-list-3-line', text: 'Solo usamos tus datos para gestionar tu solicitud de inmigracion.' },
      { icon: 'ri-forbid-2-line', text: 'Nunca vendemos ni compartimos tus datos con terceros.' },
      { icon: 'ri-lock-password-line', text: 'Tus datos estan cifrados y protegidos.' },
      { icon: 'ri-delete-bin-6-line', text: 'Puedes solicitar la eliminacion de tus datos en cualquier momento.' },
      { icon: 'ri-building-2-line', text: 'Responsable: Global Mobility Group LLC.' },
      { icon: 'ri-mail-line', text: 'Contacto: legal@globalmobility.law.' },
    ],
    fullLink: 'https://globalmobility.law/politica-privacidad',
  },
  data: {
    title: 'Acuerdo de Tratamiento de Datos',
    icon: 'ri-database-2-line',
    intro: 'Asi tratamos tus datos personales conforme a la normativa vigente:',
    points: [
      { icon: 'ri-eu-line', text: 'Tus datos se procesan conforme al RGPD y la LOPDGDD.' },
      { icon: 'ri-user-settings-line', text: 'Solo personal autorizado accede a tu informacion.' },
      { icon: 'ri-government-line', text: 'Tus datos solo se comparten con terceros cuando es necesario para tramitar tu solicitud y siempre con tu conocimiento previo.' },
      { icon: 'ri-time-line', text: 'Conservamos tus datos durante tu caso y los plazos legales.' },
      { icon: 'ri-list-check-2-line', text: 'Derechos: acceso, rectificacion, supresion, portabilidad.' },
      { icon: 'ri-mail-line', text: 'Contacto: legal@globalmobility.law.' },
    ],
    fullLink: 'https://globalmobility.law/politica-privacidad',
  },
};

export default function LegalModal({ type, open, onClose }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  const cfg = CONFIGS[type] || CONFIGS.terms;

  return (
    <div
      className="legal-modal-overlay"
      onClick={onClose}
    >
      <div
        className="legal-modal-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="legal-modal-header">
          <div className="legal-modal-title-wrap">
            <div className="legal-modal-title-icon">
              <i className={cfg.icon} />
            </div>
            <h2 className="legal-modal-title">{cfg.title}</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="legal-modal-close"
          >
            <i className="ri-close-line" />
          </button>
        </div>

        <div className="legal-modal-body">
          <p className="legal-modal-intro">{cfg.intro}</p>
          <ul className="legal-modal-list">
            {cfg.points.map((p) => (
              <li key={`${cfg.title}-${p.text}`} className="legal-modal-list-item">
                <div className="legal-modal-point-icon">
                  <i className={p.icon} />
                </div>
                <span className="legal-modal-point-text">{p.text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="legal-modal-footer">
          <a href={cfg.fullLink} target="_blank" rel="noopener noreferrer" className="legal-modal-link">
            Ver documento completo
          </a>
          <p className="legal-modal-note">Se abre en una nueva pestana. Cierrala para volver aqui.</p>
          <button
            type="button"
            onClick={onClose}
            className="legal-modal-action"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
